require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-transfer-partner.json") })
        }
      }, "path---en-pages-transfer-partner");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-transfer-partner!./.cache/json/en-pages-transfer-partner.json
// module id = 770
// module chunks = 231608221292675